<div class="component">
  <h3 [ngClass]="condensed ? 'headerCondensed' : 'header'">
    <a
      [ngClass]="condensed ? 'headerLinkCondensed' : 'headerLink'"
      [hidden]="!linkText"
      [routerLink]="linkUrl"
      [queryParams]="linkParams"
      (click)="handleClick($event)"
    >
      {{ linkText }}
      <i class="fa fa-chevron-right" [hidden]="!linkText" data-icon></i>
    </a>

    <span
      [textContent]="title"
      [ngClass]="isActive ? 'active' : ''"
      data-automation-e2e-selector="panelTitle"
    ></span>
  </h3>
  <div class="body"><ng-content></ng-content></div>
</div>
